import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useLanguage } from '@/shared/lib/hooks';

import { useGetDisclamersContentQuery } from '../../api/disclamers.api';

import cls from './prop-firm-disclamer.module.css';

export const PropFirmDisclamer = memo(() => {
    const [language] = useLanguage();
    const { t } = useTranslation('translation');

    const { data } = useGetDisclamersContentQuery({
        locale: language,
    });

    if (!data?.propFirm) return null;

    return (
        <div className={cls.root}>
            <h2 className={cls.title}>
                {data.propFirm.title || t('disclamer')}
            </h2>
            <div className={cls.content}>{data.propFirm.content}</div>
        </div>
    );
});

PropFirmDisclamer.displayName = 'PropFirmDisclamer';
